"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoleCodec = exports.UserRole = void 0;
const t = __importStar(require("io-ts"));
var UserRole;
(function (UserRole) {
    UserRole["Hacker"] = "Hacker";
    UserRole["Sponsor"] = "Sponsor";
    UserRole["Mentor"] = "Mentor";
    UserRole["Admin"] = "Admin";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
// TODO - Come up with a way to make one of these deterministic on the other, so they don't have to be kept in sync:
exports.UserRoleCodec = t.union([t.literal("Hacker"), t.literal("Sponsor"), t.literal("Mentor"), t.literal("Admin")]);
//# sourceMappingURL=UserRole.js.map